import React, { forwardRef } from 'react';

import { useDebouncedCallback } from 'use-debounce';

import SearchIcon from '@atlaskit/icon/glyph/search';
import { Box } from '@atlaskit/primitives';
import TextField from '@atlaskit/textfield';
import { token } from '@atlaskit/tokens';

type SearchInputProps = {
	placeholderText: string;
	onSearch: (searchText: string) => void;
};

export const SearchInput = forwardRef(
	({ placeholderText, onSearch }: SearchInputProps, inputRef) => {
		const [debouncedChange] = useDebouncedCallback((searchText: string) => {
			onSearch(searchText);
		}, 100);

		return (
			<TextField
				ref={inputRef}
				role="search"
				placeholder={placeholderText}
				onChange={(e) => debouncedChange(e.currentTarget.value)}
				elemBeforeInput={
					<Box paddingBlockStart="space.025" paddingInlineStart="space.100">
						<SearchIcon primaryColor={token('color.icon')} label="" />
					</Box>
				}
			/>
		);
	},
);
